import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";

const IDLE_TIMEOUT =
  (Number(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES) || 30) * 60 * 1000;
  console.log(IDLE_TIMEOUT)

export default function IdleTimer() {
    const { logout } = useAuth();

    const timerRef = useRef(null);
    const loggedOutRef = useRef(false);

    const handleLogout = () => {
        if (loggedOutRef.current) return;

        loggedOutRef.current = true;

        clearTimeout(timerRef.current);

        // Store the reason before logout
        sessionStorage.setItem("logoutReason", "idle-timeout");

        logout();
    };

    const resetTimer = () => {
        if (loggedOutRef.current) return;

        clearTimeout(timerRef.current);

        timerRef.current = setTimeout(handleLogout, IDLE_TIMEOUT);
    };

    useEffect(() => {
        loggedOutRef.current = false;

        const events = [
            "mousemove",
            "mousedown",
            "mouseup",
            "click",
            "keydown",
            "keyup",
            "scroll",
            "wheel",
            "touchstart",
            "touchmove",
        ];

        events.forEach((event) =>
            window.addEventListener(event, resetTimer, { passive: true })
        );

        resetTimer();

        return () => {
            clearTimeout(timerRef.current);

            events.forEach((event) =>
                window.removeEventListener(event, resetTimer)
            );
        };
    }, []);

    return null;


    
}